import React from 'react'

const Screen = ({ input }) => {
  return (
    <div className='input'>
        {input}
    </div>
  )
}

export default Screen